//import {startSolcatcher} from './src.js';
//await startSolcatcher()
import {getPubkey} from './../../../keyUtils/index.js';
import { createUmi } from "@metaplex-foundation/umi-bundle-defaults";
import {
  createSignerFromKeypair,
  generateSigner,
  signerIdentity,
} from "@metaplex-foundation/umi";
import {
  fetchDigitalAsset,
  mplTokenMetadata,
} from "@metaplex-foundation/mpl-token-metadata";
import { AccountNotFoundError, } from "@metaplex-foundation/umi";
import {
    fetchMetadata,
} from "@metaplex-foundation/mpl-token-metadata";
import { logResponse,getRpcUrl } from "./../FetchManager.js";
/**
 * Registry for Umi instances
 * NO CONNECTION OBJECTS - uses only custom fetch
 */
export class UmiRegistry {
  getUmi() {
    const url = getRpcUrl("umi_init");

    const umi = createUmi(url as any, {
      fetch: createRateLimitedFetch(),
    });

    umi.use(mplTokenMetadata());
    umi.use(
      signerIdentity(
        createSignerFromKeypair(umi, generateSigner(umi))
      )
    );

    return umi;
  }
}
export function sanitizeForJson(value: any): any {
  if (typeof value === "bigint") return value.toString();
  if (Array.isArray(value)) return value.map(sanitizeForJson);
  if (value && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, sanitizeForJson(v)])
    );
  }
  return value;
}
export function createRateLimitedFetch() {
  return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const method = extractMethodFromRequest(init);
    const url = getRpcUrl(method);

    const res = await fetch(url as any, init);

    logResponse(method, res.clone(), url);

    if (res.status === 429) {
      const fallbackUrl = getRpcUrl(method) as any;
      const fallbackRes = await fetch(fallbackUrl, init);
      logResponse(method, fallbackRes.clone(), fallbackUrl);
      return fallbackRes;
    }

    return res;
  };
}

export function extractMethodFromRequest(init?: RequestInit): string {
  if (!init?.body) return "default";
  try {
    const body = JSON.parse(init.body as string);
    return body.method ?? "default";
  } catch {
    return "default";
  }
}
export async function getUmiMetadata(mint: string) {
  const umi = new UmiRegistry().getUmi();
  return await fetchDigitalAsset(umi, getPubkey(mint) as any);
}
export async function getFullTokenInfo(mint: string) {
  const umi = new UmiRegistry().getUmi();

  const raw = await fetchAllTokenInfo(umi, mint);

  return sanitizeForJson(raw);
}

export async function getUmi(mint:string):Promise<any>{
    const method = 'getUmi'
    const url = getRpcUrl(method)
    const umi = createUmi(url as any);
    umi.use(mplTokenMetadata());
    const keypair = generateSigner(umi);
    umi.use(signerIdentity(createSignerFromKeypair(umi, keypair)));
    const metaData = await fetchDigitalAsset(umi, getPubkey(mint) as any);
    return metaData;
}




export async function fetchAllTokenInfo(
  umi: any,
  mint: string
) {
  const mintPk = getPubkey(mint) as any;



  /* ----------------------------
   * 2. Metaplex Metadata (OPTIONAL)
   * ---------------------------- */
  let metadataAccount: any = null;
  try {
    metadataAccount = await fetchMetadata(umi, mintPk);
  } catch (err: any) {
    if (!(err instanceof AccountNotFoundError)) {
      throw err; // real failure
    }
  }

  /* ----------------------------
   * 3. Off-chain JSON (OPTIONAL)
   * ---------------------------- */
  let offchain: any = null;
  if (metadataAccount?.uri) {
    try {
      const res = await fetch(metadataAccount.uri);
      if (res.ok) {
        offchain = await res.json();
      }
    } catch {
      /* ignore */
    }
  }

  return {
    mint,
    spl: mintPk,
    metadata: metadataAccount,
    offchain,
    hasMetadata: !!metadataAccount,
  };
}
